<template>
  <b-form-group label="">
    <div class="lower-font-size">
      <b-form-checkbox v-model="propertyValue" :disabled="disabled">
        {{ properties.label }}
      </b-form-checkbox>
    </div>
  </b-form-group>
</template>

<script>
export default {
  name: "CheckboxPropertyType",
  props: ["properties", "property", "value", "element"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    },
    disabled() {
      if (this.properties.disabled)
        return this.properties.disabled(this.element);
      return false;
    }
  }
};
</script>

<style>
.lower-font-size {
  font-size: 14px !important;
}
.lower-font-size .custom-control-label {
  padding-top: 2px;
}
</style>
